import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const IMAGE_SERVER_URL =
  'https://service-dqh4dutn-1252476205.cd.apigw.tencentcs.com/UploadFileToCOSByAPIGW-1658842972';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  constructor(private httpClient: HttpClient) {}

  uploadImage(image: any) {
    return this.httpClient
      .post<{ url: string }>(IMAGE_SERVER_URL, image)
      .toPromise();
  }
}
